import { render } from "./McpAppRenderer.vue?vue&type=template&id=8be56dfc&scoped=true"
import script from "./McpAppRenderer.vue?vue&type=script&lang=js"
export * from "./McpAppRenderer.vue?vue&type=script&lang=js"

import "./McpAppRenderer.vue?vue&type=style&index=0&id=8be56dfc&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8be56dfc"]])

export default __exports__